const question5 = {
    'question': 'Jak przebiega psychoterapia dzieci i młodzieży?',
    'answer': 'Sesje psychoterapii trwają zazwyczaj od 45 do 60 minut. W trakcie psychoterapii psychoterapeuta pomaga dziecku w zrozumieniu jego problemów, rozwijaniu umiejętności radzenia sobie ze stresem i trudnymi sytuacjami, a także rozwoju osobistym i społecznym. Psychoterapia dzieci i młodzieży może być procesem długotrwałym, wymagającym zaangażowania dziecka i jego rodziny.',
}

export default question5;